import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { PropertyCodesResultSchema } from '../markets/propertyCodes';
import { authHeader, salesApiBaseUrl } from './authHeader';
// Corporate + promo codes for a single property, used to prepopulate the search
// bar's code typeahead. Cached per property so paging back to a property (or a
// market that shares one) does not re-hit Apaleo. Codes change rarely, so the
// cache is held for the whole session rather than invalidated between searches.
export const propertyCodesApi = createApi({
    reducerPath: 'propertyCodesApi',
    baseQuery: fetchBaseQuery({
        baseUrl: salesApiBaseUrl(),
        prepareHeaders: async (headers) => {
            const auth = await authHeader();
            Object.entries(auth).forEach(([key, value]) => headers.set(key, value));
            return headers;
        }
    }),
    endpoints: builder => ({
        // POST /property-codes — the propertyId is the cache key (one entry per
        // property), so each property's codes are fetched at most once per session.
        getPropertyCodes: builder.query({
            query: propertyId => ({
                url: '/property-codes',
                method: 'POST',
                body: { propertyId }
            }),
            transformResponse: (response) => PropertyCodesResultSchema.parse(response),
            keepUnusedDataFor: 3600
        })
    })
});
export const { useGetPropertyCodesQuery } = propertyCodesApi;
